import {
  APIConnectionConfig,
  ModuleConfig,
  ModuleDisplayConfig,
  ModuleMapConfig,
} from '@schamburg-web/interfaces';
import SnowplowDisplayCard from './SnowplowDisplayCard';
import SnowplowMarker from './SnowplowMarker';

export const snowplowIcon = '/mapicons/snowplow.svg';

const mapModuleConfig: ModuleMapConfig = {
  zIndex: 60,
  layerIcon: snowplowIcon,
  showOnMap: true,
  defaultEnabled: true,
};

const displayConfig: ModuleDisplayConfig = {
  label: 'Snowplow #',
  isPopupDialog: false,
  isMobilePopupDialog: true,
  isOnSideBar: true,
  popupDef: SnowplowDisplayCard,
  cardDef: SnowplowDisplayCard,
  markerDef: SnowplowMarker,
};

const apiConfig: APIConnectionConfig = {
  endpoint: 'vehicle',
  updateDelay: 60,
  publishLayer: 'vehicle',
};

const moduleConfig: ModuleConfig = {
  moduleLabel: 'Snowplows',
  name: 'snowplow',
  mapConfig: mapModuleConfig,
  displayConfig: displayConfig,
  apiConfig: apiConfig,
};

export default moduleConfig;
